import config from '@iotv/config'
import type { UserAttributeDefs } from '../../types/ModelTypes'

export type DefaultContactDetailsType = {
  email: string
  /** @deprecated in favour of {@link DefaultContactDetailsType.phoneNumber | phoneNumber} */
  phone_number?: string
  phoneNumber?: string
}

export const DefaultContactDetails: UserAttributeDefs = {
  email: {
    type: 'String',
    editable: true,
    required: true,
    validation: {
      regex: config.app.regex.email,
      pass: true,
      invalidMessage: 'Not a valid email address',
    },
  },
  phoneNumber: {
    type: 'String',
    editable: true,
    required: true,
    validation: {
      regex: /^[0-9\+ ]+$/,
      pass: true,
      invalidMessage: 'Phone number invalid',
    },
  },
}
